import React from "react";
import RichTextRenderer from "./RichTextRenderer"; // Ensure this path is correct

/**
 * Legacy Adapter for handleRichTextOutput.
 * Routes all old configurations into the robust RichTextRenderer engine
 * without needing a global find-and-replace.
 */
export const handleRichTextOutput = (
  richTextValue,
  {
    lengthLimit = 0, // chars; 0 = unlimited
    previewOnly = false, // true = plain text preview (recommended for cards)
    clampLines = 0, // optional CSS line clamp (0 = off)
    className = "",
    titleFullText = false, // if true, puts full text in title tooltip
  } = {}
) => {
  // 1. Replicate legacy behavior of returning null for empty values
  if (!richTextValue) return null;

  // 2. Map the legacy length limit (where 0 = unlimited) to the new previewLength
  const resolvedPreviewLength = lengthLimit > 0 ? lengthLimit : 999999;

  // 3. Replicate the title tool-tip extraction ONLY if explicitly requested
  let tooltipText = undefined;
  if (titleFullText) {
    try {
      const parsed =
        typeof richTextValue === "string"
          ? JSON.parse(richTextValue)
          : richTextValue;
      if (parsed?.html) {
        // Safe DOM extraction
        const doc = new DOMParser().parseFromString(
          String(parsed.html),
          "text/html"
        );
        tooltipText = (doc.body?.textContent || "").replace(/\s+/g, " ").trim();
      }
    } catch {
      // Fallback for raw text
      tooltipText = String(richTextValue)
        .replace(/<\/?[a-z][\s\S]*>/i, "")
        .replace(/\s+/g, " ")
        .trim();
    }
  }

  // 4. Return the new component!
  // We wrap it in a div with `display: contents` so the tooltip works
  // without messing up your flexbox or grid layouts in the parent components.
  return (
    <div title={tooltipText} style={{ display: "contents" }}>
      <RichTextRenderer
        value={richTextValue}
        preview={previewOnly}
        previewLength={resolvedPreviewLength}
        clampLines={clampLines > 0 ? clampLines : undefined}
        className={className}
        emptyText="" // Legacy code didn't render "—", so we enforce empty strings here
      />
    </div>
  );
};
